export const MOBILE_TEMPORARY_LOCATION_KEY = 'mobile-temporary-location';
export const MOBILE_TEMPORARY_LOCATION_TTL_MS = 5 * 60 * 1000;

export interface MobileTemporaryLocation {
    spot_id: string;
    expires_at: number;
}

export function isTemporaryLocationValid(value: MobileTemporaryLocation | null | undefined, now = Date.now()): value is MobileTemporaryLocation {
    return !!value?.spot_id && typeof value.expires_at === 'number' && value.expires_at > now;
}

export function getTemporaryLocationSpotId(value: MobileTemporaryLocation | null | undefined, now = Date.now()): string | undefined {
    return isTemporaryLocationValid(value, now) ? value.spot_id : undefined;
}

export function createTemporaryLocation(spotId: string, now = Date.now()): MobileTemporaryLocation {
    return {
        spot_id: spotId,
        expires_at: now + MOBILE_TEMPORARY_LOCATION_TTL_MS
    };
}

/** Great-circle distance in metres (WGS84 approx). */
export function distanceMeters(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const toRad = (deg: number) => (deg * Math.PI) / 180;
    const earthRadiusM = 6371000;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 2 * earthRadiusM * Math.asin(Math.sqrt(a));
}

/**
 * Distance to a SPOT, also trying lat/lng swapped (common data-entry mistake).
 * Uses the smaller distance; `coordsSwapped` is true when the swapped orientation is closer.
 */
export function distanceToSpotMeters(
    deviceLat: number,
    deviceLng: number,
    spotLat: number,
    spotLng: number
): { distance: number; coordsSwapped: boolean; effectiveLat: number; effectiveLng: number } {
    const asStored = distanceMeters(deviceLat, deviceLng, spotLat, spotLng);
    const swapped = distanceMeters(deviceLat, deviceLng, spotLng, spotLat);
    if (swapped + 1 < asStored) {
        return { distance: swapped, coordsSwapped: true, effectiveLat: spotLng, effectiveLng: spotLat };
    }
    return { distance: asStored, coordsSwapped: false, effectiveLat: spotLat, effectiveLng: spotLng };
}

export const GEO_SUGGEST_RADIUS_METERS = 75;
